<!--
  -  Filename........: Magento1Edit.vue
  -  Project.........: logistik-app
  -  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
  -  @version........: 1.0
  -
  -  @since..........: 22.07.20, 14:17
  -  @author.........: Robin Rick
  -
  -  @brief..........:
  -->
<template>
  <form method="post" @submit="submitForm">
    <div v-for="(message, index) in messages">
      <p :class="'alert alert-'+message.type" role="alert">{{ message.text }}
        <span class="pull-right" @click="messages.splice(index)">
                                    <i class="fas fa-times-circle"></i>
                                </span>
      </p>
    </div>
    <v-row>
      <v-col>
        <v-select id="department" name="host_url" v-model="shop.department_id" required :items="departments"
                  item-value="id"
                  label="Abteilung"
                  item-text="name"></v-select>
        <v-text-field
            v-model="shop.host_url"
            required
            type="text"
            label="Shop-WSDL-URL ( https://YOURSHOP-URL/api/v2_soap/?wsdl )"
        ></v-text-field>
        <v-text-field
            v-model="shop.username"
            required
            type="text"
            label="API username"
        ></v-text-field>
        <v-text-field
            v-model="shop.api_key"
            required
            type="password"
            label="API-Key"
        ></v-text-field>
        <v-select :items="[{'text': 'Nein', 'value': false}, {'text': 'Ja', 'value': true}]" v-model="shop.active"
        ></v-select>
        <v-combobox multiple chips label="Zusätzliche Attribute laden:"
                    :items="configAttributes"
                    v-model="configAttributes">
        </v-combobox>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn type="button" color="primary" right @click="submitForm">
          Abschicken
        </v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import magento1service from "../services/magento1service";
import departmentService from "js/services/departmentService";
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-end',
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export default {
  name: "Magento1Edit",
  props: [
    'mode',
    'id'
  ],
  data() {
    return {
      updateData: {},
      messages: [],
      configAttributes: [],
      shop: {
        username: null,
        host_url: null,
        department_id: null,
        api_key: null,
        active: false,
        config: []
      },
      departments: []
    }
  },
  methods: {
    submitForm(e) {
      this.prepareConfigForSave();
      if (this.id) {
        Swal.fire({
          title: 'Bestätigung Erforderlich',
          text: 'Sind Sie sicher, dass sie die Änderungen übernehmen wollen?',
          confirmButtonText: 'Ja',
          denyButtonText: 'Abbrechen',
          showDenyButton: true
        }).then((result) => {
          if (result.isConfirmed) {
            magento1service.update(this.id, this.shop).then(
                (response) => {
                  if (response.status === 200) {
                    this.$eventBus.$emit('magento1-created-updated');
                    Toast.fire({text: response.data.message, icon: 'success'})
                  } else {
                    Toast.fire({text: response.data.message, icon: 'error'})
                  }
                }
            );
          }
        })
      } else {
        magento1service.create(this.shop).then(
            (response) => {
              if (response.status === 200) {
                this.$eventBus.$emit('magento1-created-updated');
                Toast.fire({text: response.data.message, icon: 'success'})
              } else {
                Toast.fire({text: response.data.message, icon: 'error'})
              }
            }
        );
      }
      e.preventDefault();
    },
    getShop() {
      magento1service.get(this.id).then(
          (response) => {
            this.shop = response;
            if (this.shop.config && this.shop.config.length) {
              this.shop.config.forEach(entry => {
                if (entry.key === 'additional_attributes') {
                  this.configAttributes = entry.value;
                }
              });
            }
          }
      );
    },
    prepareConfigForSave() {
      if (this.configAttributes && this.configAttributes.length) {
        this.shop.config = [];
        this.shop.config.push({key: 'additional_attributes', value: this.configAttributes});
      }
    },
    getDepartments() {
      departmentService.getAll().then(
          (response) => {
            this.departments = response;
          }
      )
    }
  },
  beforeMount() {
    this.getDepartments();
    if (this.id) {
      this.getShop()
    }
  },
}
</script>

<style scoped>

</style>